// src/components/NavCallToAction.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import { BRAND } from "../config/brandConfig";

function NavCallToAction({ to, label }) {
  return (
    <NavLink
      to={to}
      style={{
        textDecoration: "none",
        padding: "0.45rem 1rem",
        borderRadius: 999,
        background: `linear-gradient(135deg, ${BRAND.accent}, "#1e6091")`,
        color: "white",
        fontWeight: 600,
        fontSize: 13,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </NavLink>
  );
}

export default NavCallToAction;
